import { customizeValidator } from '@rjsf/validator-ajv6'
import { useGlobalStorages } from '@features/storages'
import { useMemo } from 'react'

import { useBotVariables } from '../../../store/flow'
import { createCustomFormats } from './utils'

export const useRjsfValidator = () => {
  const botVariables = useBotVariables()
  const globalStorages = useGlobalStorages()

  return useMemo(
    () =>
      customizeValidator({
        customFormats: createCustomFormats({ botVariables, globalStorages }) as any
      }),
    [botVariables, globalStorages]
  )
}
